import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import Drawer from 'components/Drawer';
import Loader from 'components/Loader';
import Button from 'components/Button';
import ButtonConfirmation from 'components/ButtonConfirmation';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import { loadOthersScheduling, removeOthersScheduling } from 'components/SchedulingOthersRegistration/store/thunk';

import { permanence } from 'helpers/formatters';
import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

const Line = ({ children }) => {
  return(
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {children}
    </div>
  );
}

export default function SchedulingOthersView({ id, isOpen, onClose }) {
  const dispatch = useDispatch();

  const history = useHistory();

  const { width } = useWindowDimensions();
  const isSm = width < 960;

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { isLoading, submit } = useSelector(state => state.schedulingOthers);

  useEffect(() => {
    if(id) {
      dispatch(loadOthersScheduling(userId, establishmentId, id));
    }
  }, [id]);

  return(
    <Drawer
      id='scheduling-others-drawer'
      anchor='left'
      title='Detalhes do agendamento'
      open={isOpen}
      onClose={onClose}
    >
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Loader isLoading={isLoading}>
          <Grid container>
            <Grid xs={12}>
              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginBottom: 10 }}>
                <b>{submit?.title}</b>
              </Typography>
              <Line>
                <Typography variant='subtitle2'>Funcionário</Typography>
                <Typography variant='subtitle2' color='textSecondary'>{submit?.employee || '-'}</Typography>
              </Line>
              <Line>
                <Typography variant='subtitle2'>Observação</Typography>
                <Typography variant='subtitle2' color='textSecondary'>{submit?.observation}</Typography>
              </Line>
            </Grid>
            <Grid xs={12}>
              <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA', marginTop: 10, marginBottom: 10 }}>
                <b>Data e Hora</b>
              </Typography>
              <Line>
                <Typography variant='subtitle2'>Início</Typography>
                <Typography variant='subtitle2' color='textSecondary'>{moment(submit?.dateStart, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {submit?.timeStart}</Typography>
              </Line>
              <Line>
                <Typography variant='subtitle2'>Fim</Typography>
                <Typography variant='subtitle2' color='textSecondary'>{moment(submit?.dateEnd, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {submit?.timeEnd}</Typography>
              </Line>
              <Line>
                <Typography variant='subtitle2'>Período</Typography>
                <Typography variant='subtitle2' color='textSecondary'>{permanence([`${submit?.dateEnd} ${submit?.timeEnd}`, `${submit?.dateStart} ${submit?.timeStart}`])}</Typography>
              </Line>
            </Grid>
          </Grid>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <div style={{ width: isSm ? '50%' : 'fit-content' }}>
              <ButtonConfirmation
                fullWidth={isSm}
                title='Remover Agendamento'
                color='error'
                variant='outlined'
                cancelTitle='Fechar'
                modalTitle='Confimar remoção'
                modalText={
                  <>
                    <Typography color='textSecondary' variant='subtitle2'>
                      Deseja confimar a remoção do agendamento:
                    </Typography>
                    <Typography color='primary' variant='subtitle2'>
                      {submit?.observation} ({moment(submit?.timeStart, 'HH:mm').format('HH:mma')} - {moment(submit?.timeEnd, 'HH:mm').format('HH:mma')})
                    </Typography>
                  </>
                }
                modalButtons={[
                  {
                    color: 'error',
                    title: 'Remover agendamento',
                    onClick: () => {
                      dispatch(removeOthersScheduling(userId, establishmentId, id))
                        .then(() => onClose());
                    }
                  }
                ]}
              />
            </div>
            <div style={{ width: isSm ? '50%' : 'fit-content' }}>
              <Button
                fullWidth={isSm}
                type='button'
                color='tertiary'
                variant='outlined'
                onClick={() => {
                  history.push({
                    pathname: '/editar-agendamento',
                    state: {
                      data: {
                        id
                      }
                    }
                  });
                }}
                startIcon={
                  <FontAwesomeIcon
                    size='xs'
                    icon={faPen}
                  />
                }
              >
                Editar
              </Button>
            </div>
          </div>
        </Loader>
      </div>
    </Drawer>
  );
}